import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { currentUserShowSuccess, fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

export const SAVE_SEARCH_REQUEST = 'app/SavedSearchesPage/SAVE_SEARCH_REQUEST';
export const SAVE_SEARCH_SUCCESS = 'app/SavedSearchesPage/SAVE_SEARCH_SUCCESS';
export const SAVE_SEARCH_ERROR = 'app/SavedSearchesPage/SAVE_SEARCH_ERROR';

export const DELETE_SEARCH_REQUEST = 'app/SavedSearchesPage/DELETE_SEARCH_REQUEST';
export const DELETE_SEARCH_SUCCESS = 'app/SavedSearchesPage/DELETE_SEARCH_SUCCESS';
export const DELETE_SEARCH_ERROR = 'app/SavedSearchesPage/DELETE_SEARCH_ERROR';

// ================ Reducer ================ //

const initialState = {
  saveInProgress: false,
  saveError: null,
  deleteInProgress: null, // holds searchId being deleted
  deleteError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SAVE_SEARCH_REQUEST:
      return { ...state, saveInProgress: true, saveError: null };
    case SAVE_SEARCH_SUCCESS:
      return { ...state, saveInProgress: false };
    case SAVE_SEARCH_ERROR:
      return { ...state, saveInProgress: false, saveError: payload };

    case DELETE_SEARCH_REQUEST:
      return { ...state, deleteInProgress: payload, deleteError: null };
    case DELETE_SEARCH_SUCCESS:
      return { ...state, deleteInProgress: null };
    case DELETE_SEARCH_ERROR:
      return { ...state, deleteInProgress: null, deleteError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const saveSearchRequest = () => ({ type: SAVE_SEARCH_REQUEST });
const saveSearchSuccess = () => ({ type: SAVE_SEARCH_SUCCESS });
const saveSearchError = error => ({ type: SAVE_SEARCH_ERROR, payload: error, error: true });

const deleteSearchRequest = searchId => ({ type: DELETE_SEARCH_REQUEST, payload: searchId });
const deleteSearchSuccess = () => ({ type: DELETE_SEARCH_SUCCESS });
const deleteSearchError = error => ({ type: DELETE_SEARCH_ERROR, payload: error, error: true });

// ================ Thunks ================ //

export const saveSearch = keywords => (dispatch, getState, sdk) => {
  const currentUser = getState().user.currentUser;
  const existing =
    currentUser?.attributes?.profile?.privateData?.savedSearches || [];
  const newSearch = {
    id: `${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
    keywords,
    createdAt: new Date().toISOString(),
  };
  const savedSearches = [...existing, newSearch];

  dispatch(saveSearchRequest());
  return sdk.currentUser
    .updateProfile({ privateData: { savedSearches } }, { expand: true })
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the updateProfile response');
      }
      dispatch(currentUserShowSuccess(entities[0]));
      dispatch(saveSearchSuccess());
    })
    .catch(e => dispatch(saveSearchError(storableError(e))));
};

export const deleteSavedSearch = searchId => (dispatch, getState, sdk) => {
  const currentUser = getState().user.currentUser;
  const existing =
    currentUser?.attributes?.profile?.privateData?.savedSearches || [];
  const savedSearches = existing.filter(s => s.id !== searchId);

  dispatch(deleteSearchRequest(searchId));
  return sdk.currentUser
    .updateProfile({ privateData: { savedSearches } }, { expand: true })
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the updateProfile response');
      }
      dispatch(currentUserShowSuccess(entities[0]));
      dispatch(deleteSearchSuccess());
    })
    .catch(e => dispatch(deleteSearchError(storableError(e))));
};

export const loadData = () => (dispatch, getState, sdk) => {
  return dispatch(fetchCurrentUser({ enforce: true }));
};

export const clearNewMatches = () => (dispatch, getState, sdk) => {
  return sdk.currentUser
    .updateProfile({ privateData: { savedSearchNewMatches: [] } }, { expand: true })
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length === 1) {
        dispatch(currentUserShowSuccess(entities[0]));
      }
    })
    .catch(e => {
      // Fire-and-forget: silently ignore errors
    });
};
